var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-field',{attrs:{"id":_vm.id,"name":_vm.name,"items":_vm.scoreSets,"value":_vm.currentScoreSet,"disabled":_vm.disabled},on:{"selected":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }